export default __webpack_public_path__ + "static/media/b08.e96f685c.jpg";